import { render } from "./ShopifyMigration.vue?vue&type=template&id=127a495f&scoped=true"
import script from "./ShopifyMigration.vue?vue&type=script&lang=js"
export * from "./ShopifyMigration.vue?vue&type=script&lang=js"

import "./ShopifyMigration.vue?vue&type=style&index=0&id=127a495f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127a495f"]])

export default __exports__